import React, {useCallback, useEffect, useState} from 'react'
import {Button, List, Popconfirm, Tag} from 'antd'
import {Routes, Route, Link} from 'react-router-dom'
import {Header, Title} from '../users/styles'
import {DeleteOutlined} from '@ant-design/icons'
import {formatDateTime, formatPhoneNumber} from '../../utils'
import {
  deleteEvolutionInstance,
  getEvolutionInstances,
} from '../../services/evolution'
import AdminLayout from '../../components/admin-layout'
import { toast } from 'sonner'
import EditEvolution from './Edit'

export default function Evolution() {
  return (
    <AdminLayout>
      <Routes>
        <Route index path={'/'} element={<EvolutionList/>}/>
        <Route index path={'/:id'} element={<EditEvolution/>}/>
      </Routes>
    </AdminLayout>
  )
}

function EvolutionList() {
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(25)
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const [instances, setInstances] = useState([])

  const reload = useCallback(async (page, perPage) => {
    setLoading(true)
    const {data, total} = await getEvolutionInstances({perPage, page})
    setInstances(data)
    setTotal(total)
    setLoading(false)
  }, [])

  useEffect(() => {
    reload(page, perPage).catch(() => toast.error('Falha ao carregar evolution'))
  }, [page, perPage, reload])

  return (
    <>
      <List
        orientation={'left'}
        itemLayout={'horizontal'}
        dataSource={instances}
        loading={loading}
        header={
          <Header>
            <Title>Instâncias Evolution</Title>
          </Header>
        }
        pagination={{
          position: 'bottom',
          align: 'end',
          onChange: (page, perPage) => {
            setPage(page)
            setPerPage(perPage)
          },
          total,
          pageSize: perPage,
          current: page,
          showSizeChanger: true,
          pageSizeOptions: [10, 20, 30],
        }}
        renderItem={(item) => <InstanceContainer reload={reload} data={item}/>}
      />
    </>
  )
}

function InstanceContainer({data, reload}) {
  const [color, setColor] = useState('purple')
  const [status] = useState(data.status?.instance.state)
  const [phoneNumber, setPhoneNumber] = useState('')

  const getStatus = () => {
    return status
      ? status === 'open'
        ? 'Conectado'
        : status === 'connecting'
          ? 'Qrcode'
          : 'Desconectado'
      : 'Inativo'
  }

  const getConnectedSince = () => {
    if (!data.instanceData?.updatedAt) return 'Data indisponível'
    return formatDateTime(data.instanceData?.updatedAt)
  }

  const getPhoneNumber = useCallback((data) => {
    if (!data.instanceData?.ownerJid)
      return setPhoneNumber('Número não conectado')
    const formatedNumber = formatPhoneNumber(
      data.instanceData?.ownerJid.split('@')[0]
    )
    return setPhoneNumber(formatedNumber)
  }, [])

  useEffect(() => {
    if (!data) return
    getPhoneNumber(data)
  }, [data, getPhoneNumber])

  useEffect(() => {
    if (!status) setColor('red')
    if (status === 'close') setColor('red')
    if (status === 'open') setColor('green')
    if (status === 'connecting') setColor('yellow')
  }, [status])

  return (
    <List.Item
      actions={[
        <Tag color={color}>{getStatus()}</Tag>,
        <Link to={`${data?.id}`}>
          <Button type={'text'}>Editar</Button>
        </Link>,
        <Popconfirm
          title="Você tem certeza?"
          description="Essa ação vai deletar a instância"
          onConfirm={async () => {
            await deleteEvolutionInstance(data?.id)
            toast.success("Sucesso ao deletar")
            await reload().catch(console.error)
          }}
          cancelText={'Cancelar'}
        >
          <Button
            danger
            type={'text'}
            style={{marginLeft: '1rem'}}
            icon={<DeleteOutlined/>}
          />
        </Popconfirm>,
      ]}
    >
      <List.Item.Meta
        key={data.id}
        title={
          <Link to={`/assistants/${data.assistantID}`}>
            {data.assistant?.name}
          </Link>
        }
        description={`${getConnectedSince()} | ${phoneNumber}`}
      />
    </List.Item>
  )
}
